import { IndustryProductID, OptionAvailability } from './../../../model/industry';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LoadingService } from './../../../core/services/loading.service';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { IndustryDescription, IndustryPurchasedInfo } from 'src/app/model/industry';
import { Feature } from 'src/app/model/feature';
import { CmsObject } from 'src/app/model/cmsobject';
import { CmsService } from 'src/app/core/services/cms.service';
import { FunctionalityGroup, IsoCountryCode } from 'src/app/model/configuration';
import { MagoWebService } from 'src/app/core/services/mago-web.service';
import { MagoCloudService } from 'src/app/core/services/mago-cloud.service';

@Component({
    selector: 'ms-functionalities-selection',
    templateUrl: './functionalities-selection.component.html',
    styleUrls: ['./functionalities-selection.component.scss'],
})
export class FunctionalitiesSelectionComponent implements OnInit {
    @Input() functionalitygroups: FunctionalityGroup[];
    @Input() editionSelected = '';
    @Input() currentIndustry: IndustryDescription;
    @Input() currIndustryPurchInfo: IndustryPurchasedInfo = new IndustryPurchasedInfo();
    @Input() moduleCode = '';
    @Input() version = '';
    @Input() countrySelected = '';
    @Input() parent = '';
    @Output() featureClicked = new EventEmitter<Feature>();

    public editionDescription = '';
    public editionPrefixForPrices = '';
    public currency = '';
    public calfullNr: number = 0;
    public loading: boolean = true;
    public cmsObj: CmsObject[];
    public storeObj: CmsObject[];
    public isoCountryCodeList: IsoCountryCode[] = [];
    public featureDataSheet: CmsObject[];
    public industryconfiguratorObj: CmsObject[];
    public cmsSpecializedUserExplanation: string;
    cmsTecnicalSetupExplanation = '';

    constructor(
        public loadingService: LoadingService,
        private configurationService: ConfigurationService,
        private workflow: WorkFlowService,
        public cmsService: CmsService,
        private magoWebService: MagoWebService,
        private magoCloudService: MagoCloudService
    ) {}

    async ngOnInit() {
        this.loading = true;
        this.loadingService.setLoading(this.loading);
        await this.getCmsObj();
        //carico le descrizioni e i titoli delle feature dal db
        await this.cmsService.getFeatureDataSheets();
        this.loading = false;
        this.loadingService.setLoading(this.loading);
    }

    public async getCmsObj() {
        const lang = this.workflow.getLanguageForCms();
        //recupero le stringhe della pagina
        this.cmsObj = await this.cmsService.getCmsObj(lang, 'industryAlaCarteConfigurator');
        this.storeObj = await this.cmsService.getCmsObj(lang, 'store');
        this.industryconfiguratorObj = await this.cmsService.getCmsObj(lang, 'industryconfigurator');

        this.cmsSpecializedUserExplanation = this.cmsObj.find(
            (x) => x.ContentName == 'industryAlaCarteConfigurator.SpecializedUserExplanation'
        ).ContentTranslation;

        this.cmsTecnicalSetupExplanation = this.cmsObj.find(
            (x) => x.ContentName == 'industryAlaCarteConfigurator.TecnicalSetupExplanation'
        ).ContentTranslation;
    }
    async getSupportedIsoCountries() {
        let culture = this.workflow.getLanguageForCms();
        let data: IsoCountryCode[] = await this.configurationService.getAllSupportedISOCountryCode(culture);
        if (data === null || data === undefined) {
            return;
        }
        this.isoCountryCodeList = data;
    }
    onfeatureclick(feature: Feature) {
        let isCountable =
            feature.Options.findIndex(
                (x) => x.edition.toLowerCase() == this.editionSelected && x.availability.toLowerCase() === OptionAvailability.COUNT
            ) > -1;
        let isPPt =
            feature.Options.findIndex(
                (x) => x.edition.toLowerCase() == this.editionSelected && x.availability.toLowerCase() === OptionAvailability.PPT
            ) > -1;
        if (isCountable) feature.isChecked = feature.CurrNrOfUser > 0;
        if (isPPt) {
            if (feature.isChecked == undefined) feature.isChecked = true;
            if (feature.isChecked) {
                let i = this.currIndustryPurchInfo.PptFeatures.findIndex((x) => x.Fragment.toLowerCase() == feature.Fragment.toLowerCase());
                if (i > -1) this.currIndustryPurchInfo.PptFeatures.splice(i, 1, feature);
                else this.currIndustryPurchInfo.PptFeatures.push(feature);
            } else {
                let i = this.currIndustryPurchInfo.PptFeatures.findIndex((x) => x.Fragment.toLowerCase() == feature.Fragment.toLowerCase());
                if (i > -1) this.currIndustryPurchInfo.PptFeatures.splice(i, 1);
            }
        }
        feature.SelectedByUser = feature.isChecked;
        setTimeout(() => {
            if (this.currIndustryPurchInfo.productID == IndustryProductID.MW) {
                this.magoWebService.managePrerequisitesOrIncompatibilities(feature, true);
                this.magoWebService.manageOptionInfo(feature);
                this.configurationService.optFeatureSelected = this.currIndustryPurchInfo.OptionalFeatures;
                this.configurationService.optCountableFeatureSelected = this.currIndustryPurchInfo.CountableFeatures;
                //devo mergiare le due optioninfo
                this.magoWebService.selectedOptionInfo.forEach((element) => {
                    let index = this.configurationService.selectedOptionInfo.findIndex((x) => x.optionID == element.optionID);
                    if (index == -1) this.configurationService.selectedOptionInfo.push(element);
                });
                this.currIndustryPurchInfo.OptionalFeaturesOptionInfo = this.configurationService.selectedOptionInfo;
            } else {
                if (this.currIndustryPurchInfo.productID == IndustryProductID.MC) {
                    this.magoCloudService.managePrerequisitesOrIncompatibilities(feature, true);
                    this.magoCloudService.manageOptionInfo(feature);
                    this.configurationService.optFeatureSelected = this.currIndustryPurchInfo.OptionalFeatures;
                    this.configurationService.optCountableFeatureSelected = this.currIndustryPurchInfo.CountableFeatures;
                    //devo mergiare le due optioninfo
                    this.magoCloudService.selectedOptionInfo.forEach((element) => {
                        let index = this.configurationService.selectedOptionInfo.findIndex((x) => x.optionID == element.optionID);
                        if (index == -1) this.configurationService.selectedOptionInfo.push(element);
                    });
                    this.currIndustryPurchInfo.OptionalFeaturesOptionInfo = this.configurationService.selectedOptionInfo;
                }
            }
            this.featureClicked.emit(feature);
        });
    }

    getFeatureDataSheetDetail(fragment: string) {
        return this.cmsService.getFeatureDataSheetDetail(fragment);
    }
}
